// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — help-list.styled.classic.js, новая — help-list.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './help-list.styled.classic';
import * as cp from './help-list.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const Item = isCp ? cp.Item : classic.Item;
export const ItemContent = isCp ? cp.ItemContent : classic.ItemContent;
export const ItemTitle = isCp ? cp.ItemTitle : classic.ItemTitle;
